import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuth } from 'firebase/auth';
import { getFirestore, collection, getDocs, doc, deleteDoc } from 'firebase/firestore';
import firebaseApp from '../../firebase/credenciales';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faAdd, faReply } from '@fortawesome/free-solid-svg-icons';
import './SettingUsers.css';

const MySwal = withReactContent(Swal);

const SettingUsers = () => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const auth = getAuth(firebaseApp);
    const currentUser = auth.currentUser;
    const navigate = useNavigate();
    useEffect(() => {
        const fetchData = async () => {
            const db = getFirestore(firebaseApp);
            const querySnapshot = await getDocs(collection(db, 'usuarios'));
            const usersData = querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            usersData.sort((a, b) => a.correo.localeCompare(b.correo));
            const filteredUsers = usersData.filter(user => user.correo !== currentUser.email);
            setUsers(filteredUsers);
            setFilteredUsers(filteredUsers);
            setLoading(false);
        };

        fetchData();
    }, [currentUser]);

    useEffect(() => {
        const results = users.filter(user =>
            user.correo.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredUsers(results);
    }, [searchTerm, users]);

    const handleDeleteUser = async (id) => {
        MySwal.fire({
            title: '¿Estás seguro?',
            text: "No podrás revertir esta acción!",
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, borrarlo!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                const db = getFirestore(firebaseApp);
                const userDoc = doc(db, 'usuarios', id);
                try {
                    await deleteDoc(userDoc);
                    const newUsers = users.filter((user) => user.id !== id);
                    setUsers(newUsers);
                    setFilteredUsers(newUsers);
                    MySwal.fire(
                        'Borrado!',
                        'El usuario ha sido eliminado.',
                    );
                } catch (error) {
                    console.error("Error removing document: ", error);
                    MySwal.fire(
                        'Error!',
                        'Hubo un problema al eliminar el usuario.',
                    );
                }
            }
        });
    };

    return (
        <div className="setting-users-container">
            <div className="title-actions">
                <h1 className="title">Gestión de Usuarios</h1>
                <div className="btn-actions">
                    <button className="btn-cancel" title="Regresar" onClick={() => navigate('/admin')}><FontAwesomeIcon icon={faReply} /></button>
                    <button className="btn-plus" title="Agregar un estado" onClick={() => navigate('/register')}><FontAwesomeIcon icon={faAdd} /></button>
                </div>
            </div>
            <input
                type="text"
                placeholder="Buscar por el correo del usuario"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="search-input"
            />
            {loading ? (
                <div className="spinner"></div>
            ) : (
                <div className="user-list">
                    {filteredUsers.length === 0 ? (
                        <p className="no-results">El correo que buscas no se encuentra registrado aún.</p>
                    ) : (
                        <div className="user-list">
                            <div className="user-header">
                                <span>Correo</span>
                                <span>Rol</span>
                                <span>Acciones</span>
                            </div>
                            <ul>
                                {filteredUsers.map(state => (
                                    <li key={state.id}>
                                        <span>{state.correo}</span>
                                        <span>{state.rol}</span>
                                        <button className="btn-de" title="Eliminar" onClick={() => handleDeleteUser(state.id)}><FontAwesomeIcon icon={faTrash} /></button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>
            )}
        </div>

    );
};

export default SettingUsers;